var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStat04(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 250 219.06451612903038",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke-width:0px;}.cls-1,.cls-2,.cls-3,.cls-4{fill:none;}.cls-2,.cls-3{stroke:#e8ba3a;}.cls-2,.cls-3,.cls-4{stroke-linecap:round;stroke-linejoin:round;stroke-width:5px;}.cls-5{clip-path:url(#clippath);}.cls-3{stroke-dasharray:0 0 5.66556978225708 5.66556978225708;}.cls-4{stroke:#193c34;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 7.709677419350555,
    y: 8.129032258064399,
    width: 234.5806451612989,
    height: 203.22580645161543
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2773"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2779"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2781",
    className: "cls-2",
    d: "m70.241240329889479,81.873650288061981h13.764689141638883c3.209865404700395,0,5.811916361861222-2.602050182458697,5.811916361861222-5.811915587159092h0c0-3.20986540470949-2.602050957160827-5.81191558718092-5.811916361861222-5.81191558718092h-6.387644147469473c-3.084971913640402,0-5.58588895676985-2.500917430468689-5.58588895676985-5.585889731448333h0c0-3.084972300990557,2.500916655790206-5.585685214720797,5.58588895676985-5.585685214720797h10.784709071400357"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2783"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2785",
    className: "cls-2",
    d: "m80.029563223439254,59.07820853206249v-6.996069046499542"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2787"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2789",
    className: "cls-2",
    d: "m80.029563223439254,88.869761942223704v-6.996069046501361"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2791"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2793",
    className: "cls-4",
    d: "m110.835315134718257,70.475926311322837c0,17.009891010229694-13.789262137528567,30.798950180389511-30.798950180389511,30.798950180389511-17.009892559599393,0-30.799148499649164-13.789059170159817-30.799148499649164-30.798950180389511s13.789262137528567-30.798950180389511,30.799151598388562-30.798950180389511c17.009684944121545,0,30.798947081650113,13.789059170159817,30.798947081650113,30.798950180389511Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2795"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2797",
    className: "cls-4",
    d: "m73.755683835239324,100.63393962891314v17.242618662508903h-7.655872578339768l13.934259856290737,17.798039640410934,13.934057663609565-17.798039640410934h-7.655871803650371v-17.24160382566879"
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 20.838709683383513,
    y: 191.21364762201324,
    width: 205.85491213468504,
    height: 14.074736265214142,
    rx: 5.765432391473653,
    ry: 5.765432391473653
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m51.285518037308066,172.576162837513039c1.045795001951774-2.882782633490933,7.620933505000721-18.571802387979915,25.041702584590894-12.669515302110085.239802841510027.0812469993798.378146910770738.338771129010638.30837516108113.582160489198941-.839682051351701,2.929117847081216-6.473754688980989,19.467641809420456-25.06114074935067,12.698131779790856-.247048814220761-.089974965840156-.378600628870117-.363614987440087-.288936996321354-.610776966879712Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m51.229102242978115,172.576162837513039c-1.045795001948136-2.882782633490933-7.620933505007997-18.571802387979915-25.041702584578161-12.669515302110085-.239802841520941.0812469993798-.378146910781652.338771129010638-.308375161090225.582160489198941.839682051349882,2.929117847081216,6.473754688970075,19.467641809420456,25.061140749348851,12.698131779790856.247048814220761-.089974965840156.378600628870117-.363614987440087.288936996319535-.610776966879712Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 51.229102242978115,
    y1: 172.57616283751304,
    x2: 51.229102242978115,
    y2: 191.21364757929223
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m108.829983920299128,172.576162837513039c1.045795001949955-2.882782633490933,7.620933505000721-18.571802387979915,25.041702584589075-12.669515302110085.239802841511846.0812469993798.378146910770738.338771129010638.30837516108113.582160489198941-.839682051349882,2.929117847081216-6.47375468897917,19.467641809420456-25.06114074935067,12.698131779790856-.247048814218942-.089974965840156-.378600628870117-.363614987440087-.288936996319535-.610776966879712Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m108.773568125958263,172.576162837513039c-1.045795001939041-2.882782633490933-7.620933504989807-18.571802387979915-25.041702584578161-12.669515302110085-.239802841511846.0812469993798-.378146910770738.338771129010638-.308375161090225.582160489198941.839682051358977,2.929117847081216,6.47375468897917,19.467641809420456,25.061140749359765,12.698131779790856.247048814218942-.089974965840156.378600628859203-.363614987440087.288936996308621-.610776966879712Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 108.77356812595826,
    y1: 172.57616283751304,
    x2: 108.77356812595826,
    y2: 191.21364757929223
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m206.346696131528006,108.480207436403361l-.016546708699025,4.379464182018637c.09996166134988,1.448962628421214-.254813737359655,2.892995847310885-1.014839123188722,4.130673691170159l-10.795366105601715,10.612133820381132c-.582824740529759.949112071330092-.929928772438871,2.023976906579264-1.012284120059121,3.134704595449875l-.151287366319593,53.18101393572033c-.270090561340112,3.642715059138936-3.304360856340281,6.460337252348836-6.957075177690058,6.460337252348836h-.000012598580724c-3.501962350750546,0-6.461210797520835-2.596277821468902-6.91686756873969-6.068469811109026l-3.236125668277964-55.528842584291851"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m174.090988514210039,108.835771019143067l5.519785725218753-31.793966540270048c.580283941540984-3.342435503320303,3.480923622850241-5.782881212720895,6.873357048380058-5.782881212720895h10.464569019230112c3.666491978690829,0,6.707284439060459,2.838240543340362,6.95963018079965,6.496038385830616l1.348216717420655,19.542648772339817"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m187.837934827779463,88.08182784379278v7.418992986560625c0,2.152512688358911-1.004621868210961,4.181689086948609-2.716409602910062,5.486715379749512l-19.773462192109946,15.074817710808929c-1.700237721490339,1.296220837180954-2.194466585509872,3.64227783160095-1.16165256234126,5.514253248600653l.000004031549906.000007307180567c1.207838395741419,2.189207092280412,4.01796768757049,2.896229260430118,6.118011534201287,1.539277851828956l25.904049107910396-16.738000962028309c1.850545188370234-1.195736890951594,2.968185276778968-3.248560254090989,2.968185276778968-5.451808811681985v-12.844254711018948"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g1268"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1270",
    className: "cls-4",
    d: "m179.494889942739974,55.00333965664322c0,5.922660011559856,4.801292027668751,10.723952380139963,10.723952380129049,10.723952380139963s10.723952380129049-4.801292368580107,10.723952380129049-10.723952380139963"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m178.053581231839416,47.136289902102362c0-6.789359051908832,5.503862975969241-12.293222027879892,12.293222027868978-12.293222027879892,6.789359051901556,0,12.293222027881711,5.50386297597106,12.293222027881711,12.293222027879892"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 172.06451612902856,
    y1: 48.64637105044494,
    x2: 209.80645161289976,
    y2: 48.64637105044494
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "166.580656698819439 123.57584519095326 147.522466052369055 137.720248773523053 151.096774193545571 145.743145243994149 211.935483870964163 104.71088717947714 211.14531521356912 93.373233120562873 199.09276194245831 101.946955864032134"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m200.940462179789392,121.846032943201863l12.813493925579678,59.11415578426022c1.824176660829835,4.5015356574404-1.488542011729805,9.418346186030249-6.345644415951028,9.418346186030249h-.000014930568796c-2.865629022160647,0-5.428118890778933-1.784558677109089-6.421935630469306-4.472338054329157l-7.543729169621656-32.310124214691314"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "206.346696131528006 108.480207436403361 206.330149422828981 112.859671618421999 229.161290322579589 111.515194069503195 221.182187127438738 74.643338251993555 203.852342303569458 77.278369042373015 205.246487140288082 97.298284589653122"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 146.49567634828418,
    y1: 142.2249322706666,
    x2: 144.03278572328418,
    y2: 142.6544977003541
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 138.45148689515918,
    y1: 143.6280084425416,
    x2: 130.07966072328418,
    y2: 145.0882135206666
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 127.28888923890918,
    y1: 145.5750299269166,
    x2: 124.82599861390918,
    y2: 146.0045953566041
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 146.49567634828418,
    y1: 142.2249322706666,
    x2: 144.42951423890918,
    y2: 143.6324029737916
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 139.74689705140918,
    y1: 146.8218560987916,
    x2: 132.72321541078418,
    y2: 151.6061578566041
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 130.38190681703418,
    y1: 153.2008844191041,
    x2: 128.31574470765918,
    y2: 154.6083551222291
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 146.49567634828418,
    y1: 142.2249322706666,
    x2: 145.19416267640918,
    y2: 144.3594537550416
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 142.24469978578418,
    y1: 149.1968560987916,
    x2: 137.82062752015918,
    y2: 156.4527154737916
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 136.34577400453418,
    y1: 158.8714166456666,
    x2: 135.04450447328418,
    y2: 161.0059381300416
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 211.93548387096416,
    y1: 84.74314524399233,
    x2: 217.01612903225396,
    y2: 83.72701621173474
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStat04);
export default __webpack_public_path__ + "static/media/stat04.441efedc1d5acedd9cb7b911b5871c9a.svg";
export { ForwardRef as ReactComponent };